/**
 * Representation of the TimelineEntry Entity
 * 
 * @author Leander Eyer <leander.eyer@elead.ch>
 */

 export { TimelineEntry };

class TimelineEntry {

	constructor(work) {
		this.work = work;
		this.label = "";
		this.format = "";
	}

	// basic getters

	getWork() {
		return this.work;
	}

	getLabel() {
		return this.label;
	}

	setLabel(label) {
		this.label = label;
	}

	getFormat() {
		return this.format;
	}

	setFormat(format) {
		this.format = format;
	}

}
